import { render, staticRenderFns } from "./MobileEntry.vue?vue&type=template&id=90822a26&scoped=true"
import script from "./MobileEntry.vue?vue&type=script&lang=js"
export * from "./MobileEntry.vue?vue&type=script&lang=js"
import style0 from "./MobileEntry.vue?vue&type=style&index=0&id=90822a26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90822a26",
  null
  
)

export default component.exports